import { Heading as TipTapHeading } from "@tiptap/extension-heading";

/* Prevents the Heading extension from removing the data-collapsable attribute from Headings */
export const Heading = TipTapHeading.extend({
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: false,
      },
      "data-collapsable": {
        default: null,
        parseHTML: (element: HTMLElement) => {
          return element.hasAttribute("data-collapsable")
            ? element.getAttribute("data-collapsable")
            : null;
        },
      },
    };
  },
});
